import { IDetermineDefaultOrderClickHandlerProps } from './types';

/**
 * @name determineDefaultOrderClickHandler
 * @description most brands just run the selectRestaurant function as the
 *  default when the order button is clicked. However, TH has special logic
 *  so we need to have a leaf node here
 */
export const determineDefaultOrderClickHandler = ({
  restaurantAndUserRegionsMatch,
  selectRestaurant,
  setShowChangeRegionModal,
}: IDetermineDefaultOrderClickHandlerProps) => {
  if (restaurantAndUserRegionsMatch) {
    return selectRestaurant;
  } else {
    return () => setShowChangeRegionModal(true);
  }
};
